import { useContext } from 'react';
import { SecurityFiltersContext } from '../contexts/SecurityFiltersContext';

export const useSecurityFiltersContext = () => {
    return useContext(SecurityFiltersContext);
};
